;(function () {
	let swiperMulticolumn = []

	const addClasses = (slider) => {
		const slides = slider.querySelectorAll('.multicolumn-list__item')
		slides.forEach((slide) => {
			slide.classList.add('swiper-slide')
		})
	}

	const initSlider = () => {
		const sliders = document.querySelectorAll('.swiper--multicolumn')

		if (sliders && sliders.length > 0) {
			// Destroy existing sliders
			swiperMulticolumn.forEach((swiper) => {
				if (swiper && typeof swiper.destroy === 'function') {
					swiper.destroy(true, true)
				}
			})
			swiperMulticolumn = []

			sliders.forEach((slider) => {
				const btnPrev = slider.querySelector('.multicolumn__button-prev')
				const btnNext = slider.querySelector('.multicolumn__button-next')
				const wrapper = slider.querySelector('.multicolumn-list__wrapper')
				const items = slider.querySelectorAll('.multicolumn-list__item')
				const totalItems = items.length
				
				let multicolumnToShow = 4
				if (wrapper) {
					if (wrapper.classList.contains('multicolumn-list__wrapper--1')) multicolumnToShow = 1
					else if (wrapper.classList.contains('multicolumn-list__wrapper--2')) multicolumnToShow = 2
					else if (wrapper.classList.contains('multicolumn-list__wrapper--3')) multicolumnToShow = 3
					else if (wrapper.classList.contains('multicolumn-list__wrapper--4')) multicolumnToShow = 4
					else if (wrapper.classList.contains('multicolumn-list__wrapper--5')) multicolumnToShow = 5
					else if (wrapper.classList.contains('multicolumn-list__wrapper--6')) multicolumnToShow = 6
					else if (wrapper.classList.contains('multicolumn-list__wrapper--7')) multicolumnToShow = 7
					else if (wrapper.classList.contains('multicolumn-list__wrapper--8')) multicolumnToShow = 8
				}

				addClasses(slider)

				// Use the multicolumn_to_show setting, capped at 8
				const maxColumns = Math.min(multicolumnToShow, 8)

				const swiper = new Swiper(slider, {
					loop: false,
					breakpoints: {
						320: {
							slidesPerView: 2,
							slidesPerGroup: 2,
							spaceBetween: 24,
						},
						
						750: {
							slidesPerView: maxColumns >= 2 ? 2 : 1,
							slidesPerGroup: maxColumns >= 2 ? 2 : 1,
							spaceBetween: 24,
						},
						990: {
							slidesPerView: maxColumns >= 3 ? 3 : maxColumns,
							slidesPerGroup: maxColumns >= 3 ? 3 : maxColumns,
							spaceBetween: 24,
						},
						1200: {
							slidesPerView: maxColumns >= 4 ? 4 : maxColumns,
							slidesPerGroup: maxColumns >= 4 ? 4 : maxColumns,
							spaceBetween: 24,
						},
						1360: {
							slidesPerView: maxColumns >= 5 ? 5 : maxColumns,
							slidesPerGroup: maxColumns >= 5 ? 5 : maxColumns,
							spaceBetween: 24,
						},
						1600: {
							slidesPerView: maxColumns >= 6 ? 6 : maxColumns,
							slidesPerGroup: maxColumns >= 6 ? 6 : maxColumns,
							spaceBetween: 24,
						},
						1800: {
							slidesPerView: maxColumns >= 7 ? 7 : maxColumns,
							slidesPerGroup: maxColumns >= 7 ? 7 : maxColumns,
							spaceBetween: 24,
						},
						1920: {
							slidesPerView: maxColumns >= 8 ? 8 : maxColumns,
							slidesPerGroup: maxColumns >= 8 ? 8 : maxColumns,
							spaceBetween: 24,
						},
					},
					navigation: {
						nextEl: btnNext,
						prevEl: btnPrev,
					},
				})

				swiperMulticolumn.push(swiper)
			})
		}
	}

	const initMulticolumn = () => {
		const sliders = document.querySelectorAll('.swiper--multicolumn')
		if (sliders && sliders.length > 0) {
			initSlider()
		}
	}

	initMulticolumn()

	document.addEventListener('shopify:section:load', function () {
		initMulticolumn()
	})
})()
